/**
 * What a `qrvey-terraform` installer image address must look like (IM-124).
 *
 * `registry/repository:tag`, with an explicit tag. One definition, read in
 * three places, because the three used to disagree:
 *
 * - **At synth**, `infra/src/config/environments.ts` refuses a configured
 *   recommendation that is not this shape (IM-123).
 * - **At stack deploy**, the dispatcher template's `RunnerImage` parameter
 *   carries it as an `AllowedPattern`. Until v12 it carried only `MinLength:
 *   1`, so on the staging customer account a bare tag,
 *   `9.5-r-20260831-0793`, deployed cleanly; ECS read it as
 *   `docker.io/library/9.5-r-20260831-0793:latest`, and run `rmuae93hy-qy84rt`
 *   died at image pull with a 401 from Docker Hub.
 * - **On the account screen**, a deployed value that is not this shape is
 *   reported as fatal rather than as drift.
 *
 * Why a tag is required and not merely a repository: a bare `registry/repo`
 * means `:latest`, which gives two customers deploying a week apart two
 * different installers and leaves nothing able to say which.
 *
 * Neither part may contain `:`, so a registry with a port and a pinned digest
 * are both refused. Neither is something Qrvey hands out, and the synth-time
 * check has always refused them; widening that is its own decision.
 */
/**
 * The pattern as CloudFormation applies it.
 *
 * `AllowedPattern` is a Java regular expression matched against the *whole*
 * value, so it carries no anchors — the other patterns in these templates
 * (`\d{12}`, the grant's timestamp) are written the same way. The JavaScript
 * form below adds them, so the two cannot differ in anything but that.
 */
export const RUNNER_IMAGE_PATTERN = '[^\\s:]+/[^\\s:]+:[^\\s:]+';
/** The same shape, anchored for JavaScript. */
export const RUNNER_IMAGE_SHAPE = new RegExp(`^(?:${RUNNER_IMAGE_PATTERN})$`);
/** Named in the refusal a customer sees, so it carries a real example. */
export const RUNNER_IMAGE_EXAMPLE = 'qrvey.azurecr.io/qrvey-terraform:9.5-r-20260831-0793';
export const isRunnerImageAddress = (image) => RUNNER_IMAGE_SHAPE.test(image);
//# sourceMappingURL=runner-image.js.map